import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Modal from '../../components/common/Modal.js';
import { showModal } from '../../actions/shared/modal';
import { fetchDeliveryDetails } from '../actions/index.js';
import PincodeMessage from '../components/pincodeMessage.js';
import PincodeForm from '../components/pincodeForm.js';
import EstimatedDeliveryInformation from '../components/eddInfo.js';
import { ModalTypes } from '../../constants/index.js';
import {
  getServiceabilityDetailsDetails,
  getErrorInServiceabilityFetching,
  getIsCheckServiceabilityCalled,
  getProductServiceAbility
} from '../../refresh/selectors/productpage';
import { getReturnCodCommunication } from '../../refresh/selectors/featureFlagsSelector';

const EstimatedDeliveryDate = ({
  selectedSizeCode,
  showModal,
  fetchDeliveryDetails,
  fetchProductServiceability,
  edd,
  isMobile = false,
  luxeEventPush,
  newDesignLuxe,
  serviceabilityDetails,
  errorInServiceabilityFetching,
  isCheckServiceabilityCalled,
  returnCodCommunication,
  productServiceAbility,
  productData,
}) => {
  const { activePincode, eddDetails, isEDDFetching } = edd;

  let productSpecificEDDDetails = {};
  if (activePincode && selectedSizeCode && eddDetails[activePincode]) {
    productSpecificEDDDetails = eddDetails[activePincode][selectedSizeCode];
  }
  const { servicability } = productSpecificEDDDetails || {};

  return (
    <div
      className={`edd ${servicability === false ? ' edd-content-wrapper ' : ''} ${
        isEDDFetching ? ' edd-content-fetching ' : ''
      }`}
      id="edd"
      role="presentation"
    >
      <PincodeMessage edd={edd} selectedSizeCode={selectedSizeCode} showModal={showModal} />
      <EstimatedDeliveryInformation selectedSizeCode={selectedSizeCode} edd={edd} returnCodCommunication={returnCodCommunication} serviceabilityDetails={serviceabilityDetails} errorInServiceabilityFetching={errorInServiceabilityFetching} isCheckServiceabilityCalled={isCheckServiceabilityCalled} productServiceAbility={productServiceAbility}/>
      <Modal
        name={ModalTypes.EDD_PINCODE}
        className={ModalTypes.EDD_PINCODE}
        id={ModalTypes.EDD_PINCODE}
      >
        <PincodeForm
          selectedSizeCode={selectedSizeCode}
          fetchDeliveryDetails={fetchDeliveryDetails}
          edd={edd}
          isMobile={isMobile}
          luxeEventPush={luxeEventPush}
          newDesignLuxe={newDesignLuxe}
          fetchProductServiceability={fetchProductServiceability}
          returnCodCommunicationPdpEnabled={returnCodCommunication?.isPdpEnabled}
          productData={productData}
        />
      </Modal>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    product: { selectedSizeCode = '' },
    edd
  } = state;
  return {
    selectedSizeCode,
    edd,
    serviceabilityDetails: getServiceabilityDetailsDetails(state),
    errorInServiceabilityFetching: getErrorInServiceabilityFetching(state),
    isCheckServiceabilityCalled: getIsCheckServiceabilityCalled(state),
    returnCodCommunication: getReturnCodCommunication(state),
    productServiceAbility: getProductServiceAbility(state),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config)),
    fetchDeliveryDetails: pincode => dispatch(fetchDeliveryDetails(pincode)),
    fetchProductServiceability: (...args) =>{
      import(/* webpackChunkName: "static/chunk/actions" */ '../../refresh/pages/ProductPage/actions')
        .then(module => {
          const { fetchProductServiceability } = module;
          dispatch(fetchProductServiceability(...args)); // new serviceability api
        })
        .catch(error => console.log('err', error));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EstimatedDeliveryDate);
